<div #menu class="pointer btn-menu" (click)="isMenuOpen = true">
  <img src="/assets/images/grid/menuPoint.svg" />
</div>
<ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="menu" [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayOpen]="true" cdkConnectedOverlayBackdropClass="backdrop-selection"
  (backdropClick)="isMenuOpen = false" [cdkConnectedOverlayOpen]="isMenuOpen"
  [cdkConnectedOverlayPositions]="positonArea">
  <div class="overlay-warp">
    <div class="item" queDisplayByType [name]="'saveList'" [typeId]="question?.type?.id" (click)="saveList()" *ngIf="
        question?.optionsList?.isPublic != true &&
        (question?.optionsList?.answerOptionItem?.length ?? 0) > 0
      " translate>
      <img src="/assets/images/question-menu/save.svg" class="img" />
      questionMenu.saveList
    </div>
    <div *ngIf="
        (question?.collectionQuestionId == null ||
          question?.collectionQuestionId == 0) &&
        !question?.parentFollowUpQuestionId
      " queDisplayByType [name]="'addCollection'" [typeId]="question?.type?.id" class="item"
      (click)="addToCollection()" translate>
      <img src="/assets/images/question-menu/smart-black.svg" class="img" />
      questionMenu.addToCollection
    </div>
    <div queDisplayByType [name]="'no-operation'" [typeId]="question?.type?.id" [isCollection]="
        !(
          (question?.collectionQuestionId == null ||
            question?.collectionQuestionId == 0) &&
          !question?.parentFollowUpQuestionId
        )
      " [optionList]="question?.optionsList">
      <div class="no-more" translate>questionMenu.noOperation</div>
    </div>
    <div *ngIf="
        apiExposureEnabled$() && !question?.apiExposureFieldName
      " class="item" (click)="addToApiExposureCollectionFields()" translate>
      <img src="/assets/images/question-menu/smart-black.svg" class="img" />
      questionMenu.addToApiExposureCollectionFields
    </div>
    <div *ngIf="
        apiExposureEnabled$() && question?.apiExposureFieldName
      " class="item" (click)="editToApiExposureCollectionFields()" translate>
      <img src="/assets/images/question-menu/smart-black.svg" class="img" />
      questionMenu.editToApiExposureCollectionFields
    </div>
    <div *ngIf="isUnauthorized$() && !isFilterField$() && !question?.isFilterField"
      queDisplayByType [name]="'filterField'" [typeId]="question?.type?.id"
       class="item" (click)="chooseAsFilterField()"
      >
      <img src="/assets/images/question-menu/add-filter.svg" class="img">
      <span translate>questionMenu.chooseAsFilterField</span>
    </div>
    <div *ngIf="!question?.autoFillFieldId"
      queDisplayByType [name]="'autoFillField'" [typeId]="question?.type?.id"
       class="item" (click)="chooseAsAutoFillField()"
      >
      <img src="/assets/images/question-menu/table-field.svg" class="img" />
      <span translate>questionMenu.chooseAsAutoFillField</span>
    </div>
    <div *ngIf="question?.autoFillFieldId"
      queDisplayByType [name]="'autoFillField'" [typeId]="question?.type?.id"
       class="item" (click)="editAsAutoFillField()"
      >
      <img src="/assets/images/question-menu/table-field.svg" class="img" />
      <span translate>questionMenu.editAsAutoFillField</span>
    </div>
    <div *ngIf="question?.autoFillFieldId"
      queDisplayByType [name]="'autoFillField'" [typeId]="question?.type?.id"
       class="item" (click)="removeAsAutoFillField()"
      >
      <img src="/assets/images/question-menu/table-field.svg" class="img" />
      <span translate>questionMenu.removeAsAutoFillField</span>
    </div>
    <div *ngIf="isUnauthorized$() && question?.isFilterField"
      queDisplayByType [name]="'filterField'" [typeId]="question?.type?.id" class="item" (click)="removeAsFilterField()">
      <img src="/assets/images/question-menu/remove-filter.svg" class="img">
      <span translate>questionMenu.removeAsFilterField</span>
    </div>

  </div>
</ng-template>